module.exports = __webpack_public_path__ + "static/media/dsr_finance2.b850de85.svg";